var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPhysio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.305,
    height: 42,
    viewBox: "0 0 51.305 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(-237 -189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "physiotherapy",
    d: "M46.629,33.149H33.822V30.863h4.993a4.61,4.61,0,0,0,0-9.219H35.6L28.713,12.2h0a6.737,6.737,0,0,0-1.53-1.637,5.849,5.849,0,1,0-8.1,0,6.683,6.683,0,0,0-2.64,5.319V33.149H11.963a4.663,4.663,0,0,0-1.16.146A5.453,5.453,0,1,0,7.55,39.37a4.683,4.683,0,0,0,4.412,3.13H46.629a4.676,4.676,0,0,0,0-9.352Zm-7.815-8.5a1.6,1.6,0,0,1,0,3.207h-8v5.292H27.423V26.015a1.367,1.367,0,0,1,1.365-1.365Zm-6.956-3.006h-3.22l-3.871-5.422L22.32,17.968l3.475,4.866a4.358,4.358,0,0,0-1.366,2.886H19.447V15.881a3.683,3.683,0,0,1,6.692-2.124ZM23.131,3.507a2.842,2.842,0,1,1-2.842,2.843,2.846,2.846,0,0,1,2.842-2.843ZM5.452,36.785A2.446,2.446,0,1,1,7.9,34.339,2.448,2.448,0,0,1,5.452,36.785Zm18.432,2.71H11.963a1.67,1.67,0,1,1,0-3.34H23.884Zm-4.437-6.346V28.726h4.97v4.422Zm27.182,6.346H26.891v-3.34H46.629a1.67,1.67,0,1,1,0,3.34Zm0,0",
    transform: "translate(237 188.499)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M2817.668,5848.715v3.077h5.027v-3.077Z",
    transform: "translate(-2560.835 -5634.51)",
    fill: "#0060a6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhysio);
export default __webpack_public_path__ + "static/media/icon_physio.45417eaed76c5a2fd4c62283b87a5c34.svg";
export { ForwardRef as ReactComponent };